
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as uka6gwMzIpXeOv3IHVIS7Jy1_V76T6y_suVzoM7L3s3W0Meta } from "/app/pages/uk.vue?macro=true";
import { default as usztGFu6Gb_YTKjQG8lUJ4aEAMfke0l_v3mB2rXtKnNj0Meta } from "/app/pages/us.vue?macro=true";
import { default as togoX8awcVR1pcozpWndajKOB6Dc7qTB9VSYJ_QIdzXYf2AMeta } from "/app/pages/togo.vue?macro=true";
import { default as about3BeDYJHafdz3_0F8I84XDeTlPVmsANEPp0qlI_udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indiab_4GwRDQhXjpz_qCV_YdrTCSaQQkxZvpxPkbdWPSbtMMeta } from "/app/pages/india.vue?macro=true";
import { default as koreatwE19THvmGt5X9SN2k598tUpobaZrzE0Kvwz6P9aXT4Meta } from "/app/pages/korea.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_16VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as canadaO3tjkAP_cpaqUvYKCGL46NX8XXp1LL3FY0W_qqcQY8UMeta } from "/app/pages/canada.vue?macro=true";
import { default as israelJQLWbJQvm_vT4WEYy1zN_c1cBpt2SqDOswF5Irntc9kMeta } from "/app/pages/israel.vue?macro=true";
import { default as statusGxyJAiT6T08i4QnaacTYMdHkpZ5UFlYXwaNfFcltlQwMeta } from "/app/pages/status.vue?macro=true";
import { default as bahrainP_NIaAQoYO8WyMEz2qFBmu0CQkMrPWshf82ZXfgN8IgMeta } from "/app/pages/bahrain.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as failureOUzmaIxIwQCPpyYqBnvsNTX3OjffuZ6S1W_WPTGw6qYMeta } from "/app/pages/failure.vue?macro=true";
import { default as moroccoaSTqa4x8y0QxhzNNsomBp5wrBDQKFhnxSmDPSWwO6HAMeta } from "/app/pages/morocco.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as successs_Ty_pSos_cJey7loh3TOu085H8Zj1qbAiZPQc9ixQ0Meta } from "/app/pages/success.vue?macro=true";
import { default as vietnam_7hiZOG3Z5671Ge6yT6U5DO3uKMyrD1vt7YtoOQWIXIMeta } from "/app/pages/vietnam.vue?macro=true";
import { default as cambodiaJHsqWuamuTzYlV9lIyHPdKWZ_UZNwIeC0wvoq0SrvEkMeta } from "/app/pages/cambodia.vue?macro=true";
import { default as schengenOVqEmlyuLi0gYoR_CYFOtFhkg2HvG4bFRXooq2uyNbgMeta } from "/app/pages/schengen.vue?macro=true";
import { default as thailandGnQ_yMPpbZLk_8ORNoU0czhWnZf4_tniOG2Gfi9vnXIMeta } from "/app/pages/thailand.vue?macro=true";
import { default as fixsKy63MTjaBqUmfxnjUsmp1XcY9BM6ZE9SvBEqA3crfUMeta } from "/app/pages/admin/fix.vue?macro=true";
import { default as indonesiaPVhpOsWbrFkc82calqSobgvWcBP8ejtZFbdPHYq6e6QMeta } from "/app/pages/indonesia.vue?macro=true";
import { default as sri_45lankag1_kALdifBW8VgJop3Q6_3gixDGaTIV3cLJUjwQBITEMeta } from "/app/pages/sri-lanka.vue?macro=true";
import { default as send_5y4mqH2dsR1Y3jejrRhmyOVaYA5n79OYbtTKjzywXIMeta } from "/app/pages/admin/send.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as formsh3_c8pQ4hJbXdYZPsqheYYr3Ag2gGpb_gnvbOP6s_TUMeta } from "/app/pages/admin/forms.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginORwvU__0lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as new_45zealand3h_Yxa5F_YhOVv_R6sIyMJ80Fh_6i_4xvxxihTtpwAEMeta } from "/app/pages/new-zealand.vue?macro=true";
import { default as saudi_45arabiaXrJzqFK4BHEmZww_QUfzo7D6NP5_7DWh0_YoQsucZoAMeta } from "/app/pages/saudi-arabia.vue?macro=true";
import { default as couponsH82Q7l6Fq5370oi_xDB_8XHTSi_hVddrZTCerfAVrK4Meta } from "/app/pages/admin/coupons.vue?macro=true";
import { default as productshq_y1BtKqUhy2j_h_yOXj2qNJ1DCtV49RrdS9L_viRsMeta } from "/app/pages/admin/products.vue?macro=true";
import { default as indexpCKSe_CB7bSnErYdSa411S8Ild89yem7D8wp6Vm8zHsMeta } from "/app/pages/admin/emails/index.vue?macro=true";
import { default as email_45previewxMJZzXzH4KfrQ_AWnSWPI8EuAHkQI4to10WjfGQayaYMeta } from "/app/pages/admin/email-preview.vue?macro=true";
import { default as _91order_93DgX8a8QPuCoVre5uRy_NfibtDpIQ_PmEli_6ScHfCFQMeta } from "/app/pages/admin/order/[order].vue?macro=true";
import { default as _91email_93sQt_4R_B_hEpsWfkf6YJAQbQ1u_XN9m73DrgHmLmgvoMeta } from "/app/pages/admin/emails/[email].vue?macro=true";
import { default as _91author_93z9nqzWVuajfUC993RLEks7G9tYiQjKqtbRUZ08MwrrEMeta } from "/app/pages/blog/author/[author].vue?macro=true";
import { default as _91category_931u4tVljfEYCpyEUB2odUi_tjJP6lK0re2Uh9MXtI0tkMeta } from "/app/pages/blog/category/[category].vue?macro=true";
import { default as component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta } from "/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.4.0_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint_b34kuxyevtmennltgflzsv3w6q/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0 } from "/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.4.0_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint_b34kuxyevtmennltgflzsv3w6q/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "uk",
    path: "/uk",
    component: () => import("/app/pages/uk.vue")
  },
  {
    name: "us",
    path: "/us",
    component: () => import("/app/pages/us.vue")
  },
  {
    name: "togo",
    path: "/togo",
    component: () => import("/app/pages/togo.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "india",
    path: "/india",
    component: () => import("/app/pages/india.vue")
  },
  {
    name: "korea",
    path: "/korea",
    component: () => import("/app/pages/korea.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "canada",
    path: "/canada",
    component: () => import("/app/pages/canada.vue")
  },
  {
    name: "israel",
    path: "/israel",
    component: () => import("/app/pages/israel.vue")
  },
  {
    name: "status",
    path: "/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "bahrain",
    path: "/bahrain",
    component: () => import("/app/pages/bahrain.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "failure",
    path: "/failure",
    component: () => import("/app/pages/failure.vue")
  },
  {
    name: "morocco",
    path: "/morocco",
    component: () => import("/app/pages/morocco.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/app/pages/success.vue")
  },
  {
    name: "vietnam",
    path: "/vietnam",
    component: () => import("/app/pages/vietnam.vue")
  },
  {
    name: "cambodia",
    path: "/cambodia",
    component: () => import("/app/pages/cambodia.vue")
  },
  {
    name: "schengen",
    path: "/schengen",
    component: () => import("/app/pages/schengen.vue")
  },
  {
    name: "thailand",
    path: "/thailand",
    component: () => import("/app/pages/thailand.vue")
  },
  {
    name: "admin-fix",
    path: "/admin/fix",
    component: () => import("/app/pages/admin/fix.vue")
  },
  {
    name: "indonesia",
    path: "/indonesia",
    component: () => import("/app/pages/indonesia.vue")
  },
  {
    name: "sri-lanka",
    path: "/sri-lanka",
    component: () => import("/app/pages/sri-lanka.vue")
  },
  {
    name: "admin-send",
    path: "/admin/send",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/send.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "admin-forms",
    path: "/admin/forms",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/forms.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "new-zealand",
    path: "/new-zealand",
    component: () => import("/app/pages/new-zealand.vue")
  },
  {
    name: "saudi-arabia",
    path: "/saudi-arabia",
    component: () => import("/app/pages/saudi-arabia.vue")
  },
  {
    name: "admin-coupons",
    path: "/admin/coupons",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/coupons.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    component: () => import("/app/pages/admin/products.vue")
  },
  {
    name: "admin-emails",
    path: "/admin/emails",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/emails/index.vue")
  },
  {
    name: "admin-email-preview",
    path: "/admin/email-preview",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/email-preview.vue")
  },
  {
    name: "admin-order-order",
    path: "/admin/order/:order()",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/order/[order].vue")
  },
  {
    name: "admin-emails-email",
    path: "/admin/emails/:email()",
    meta: {"middleware":"admin"},
    component: () => import("/app/pages/admin/emails/[email].vue")
  },
  {
    name: "blog-author-author",
    path: "/blog/author/:author()",
    component: () => import("/app/pages/blog/author/[author].vue")
  },
  {
    name: "blog-category-category",
    path: "/blog/category/:category()",
    component: () => import("/app/pages/blog/category/[category].vue")
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/reviews",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/india/e-visa",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/vietnam/urgent-visa",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D0%B1%D0%BB%D0%BE%D0%B3-%D0%BD%D0%BE%D0%B2%D0%BE%D1%81%D1%82%D0%B8",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D0%B2%D0%B8%D0%B7%D0%B0-%D0%B2-%D0%B8%D0%BD%D0%B4%D0%B8%D1%8E-%D0%B4%D0%BE%D1%81%D1%82%D1%83%D0%BF%D0%BD%D0%B0-%D0%B4%D0%BB%D1%8F-%D1%82%D1%83%D1%80%D0%B8%D0%B7%D0%BC%D0%B0-2021",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/usa",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/visa-whatsapp-israel",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/ben-gurion-airport-open",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/cambodia-evisa-guide",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/uk-eta-price",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/business-visa-vietnam",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/thailand-to-reduce-visa-free-stay-from-60-to-30-days",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/thailand-dtv-destination-visa-long-term",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/south-korea-k-eta",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/sri-lanka-reinstates-visa-requirements-for-israelis",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/uk-england-london-urgent-visa-1-day",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/israel-introduces-mandatory-eta-il",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/uk-eta-transit",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/uk-eta-available-today-for-israelis",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/us-esta-price-israelis-2025",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/sri-lanka-visa-free-for-israelis",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/us-esta-israel-required-biometric-passport",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%9B%D7%A8%D7%98%D7%99%D7%A1-%D7%98%D7%99%D7%A1%D7%94-%D7%9E%D7%96%D7%95%D7%99%D7%A3-%D7%A4%D7%A7%D7%98%D7%99%D7%91%D7%99-%D7%96%D7%9E%D7%A0%D7%99-%D7%90%D7%9E%D7%99%D7%AA%D7%99",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/eta-il-israel-available-now-2024",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/new-sri-lanka-e-visa-180-365-days",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%9E%D7%97%D7%99%D7%A8-%D7%95%D7%99%D7%96%D7%94-%D7%94%D7%95%D7%93%D7%95-%D7%97%D7%99%D7%A0%D7%9D",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%9B%D7%9E%D7%94-%D7%96%D7%9E%D7%9F-%D7%9C%D7%95%D7%A7%D7%97-%D7%9C%D7%94%D7%95%D7%A6%D7%99%D7%90-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%90%D7%A8%D7%94%D7%91",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/esta-%D7%9C%D7%90%D7%A8%D7%A6%D7%95%D7%AA-%D7%94%D7%91%D7%A8%D7%99%D7%AA-%D7%AA%D7%A0%D7%90%D7%99%D7%9D",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%A8%D7%A9%D7%9E%D7%99-%D7%A4%D7%98%D7%95%D7%A8-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%90%D7%A8%D7%94%D7%91-esta",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%97%D7%93%D7%A9-%D7%9C%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99%D7%9D-%D7%95%D7%99%D7%96%D7%94-%D7%90%D7%9C%D7%A7%D7%98%D7%A8%D7%95%D7%A0%D7%99%D7%AA-%D7%9C%D7%95%D7%99%D7%99%D7%98%D7%A0%D7%90%D7%9D",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%95%D7%99%D7%99%D7%98%D7%A0%D7%90%D7%9D-%D7%9C%D7%9B%D7%A0%D7%99%D7%A1%D7%95%D7%AA-%D7%9E%D7%A8%D7%95%D7%91%D7%95%D7%AA-%D7%A8%D7%91-%D7%A4%D7%A2%D7%9E%D7%99%D7%AA",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%93%D7%A8%D7%99%D7%A9%D7%95%D7%AA-%D7%9C%D7%90%D7%99%D7%A9%D7%95%D7%A8-%D7%A0%D7%A1%D7%99%D7%A2%D7%94-%D7%90%D7%9C%D7%A7%D7%98%D7%A8%D7%95%D7%A0%D7%99-eta-%D7%9C%D7%A7%D7%A0%D7%93%D7%94",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%9E%D7%94-%D7%A6%D7%A8%D7%99%D7%9A-%D7%A2%D7%91%D7%95%D7%A8-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%94%D7%95%D7%93%D7%95-%D7%93%D7%A8%D7%99%D7%A9%D7%95%D7%AA",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%A1%D7%A8%D7%99-%D7%9C%D7%A0%D7%A7%D7%94-%D7%97%D7%A6%D7%99-%D7%A9%D7%A0%D7%94-180-%D7%99%D7%9E%D7%99%D7%9D",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%94%D7%90%D7%A8%D7%9B%D7%AA-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%95%D7%99%D7%90%D7%98%D7%A0%D7%9D",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%99%D7%98%D7%A0%D7%90%D7%9D-%D7%A2%D7%91%D7%95%D7%A8-%D7%94%D7%9E%D7%98%D7%99%D7%99%D7%9C-%D7%94%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99-2023",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%9E%D7%91%D7%A6%D7%A2%D7%99-%D7%A4%D7%A1%D7%97-2023",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%97%D7%96%D7%A8%D7%A0%D7%95-%D7%9C%D7%94%D7%A0%D7%A4%D7%99%D7%A7-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%95%D7%99%D7%90%D7%98%D7%A0%D7%9D-%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99%D7%9D-2023",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%A0%D7%99%D7%95-%D7%96%D7%99%D7%9C%D7%A0%D7%93-%D7%9B%D7%9C-%D7%A9%D7%A6%D7%A8%D7%99%D7%9A-%D7%9C%D7%93%D7%A2%D7%AA-nzeta",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%90%D7%9C-%D7%9E%D7%A8%D7%A7%D7%A9-%D7%95%D7%94%D7%A2%D7%A8%D7%99%D7%9D-%D7%94%D7%A7%D7%A1%D7%95%D7%9E%D7%95%D7%AA-%D7%A9%D7%9C-%D7%9E%D7%A8%D7%95%D7%A7%D7%95",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%90%D7%9C%D7%A7%D7%98%D7%A8%D7%95%D7%A0%D7%99%D7%AA-%D7%9C%D7%9E%D7%A8%D7%95%D7%A7%D7%95-%D7%94%D7%A0%D7%97%D7%99%D7%95%D7%AA",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%95%D7%AA-%D7%9C%D7%9E%D7%96%D7%A8%D7%97",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%94%D7%90%D7%9D-%D7%A6%D7%A8%D7%99%D7%9A-%D7%97%D7%99%D7%A1%D7%95%D7%A0%D7%99%D7%9D-%D7%9C%D7%95%D7%99%D7%90%D7%98%D7%A0%D7%9D-%D7%95%D7%A7%D7%9E%D7%91%D7%95%D7%93%D7%99%D7%94",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%94%D7%90%D7%9D-%D7%A6%D7%A8%D7%99%D7%9A-%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%94%D7%95%D7%93%D7%95-%D7%91%D7%A7%D7%95%D7%A0%D7%A7%D7%A9%D7%9F",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%94%D7%95%D7%93%D7%95-%D7%96%D7%9E%D7%99%D7%A0%D7%94-%D7%9C%D7%99%D7%A9%D7%A8%D7%90%D7%9C%D7%99%D7%9D-%D7%90%D7%95%D7%A7%D7%98%D7%95%D7%91%D7%A8-2021",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%A2%D7%95%D7%A0%D7%95%D7%AA-%D7%9E%D7%95%D7%9E%D7%9C%D7%A6%D7%95%D7%AA-%D7%9C%D7%98%D7%99%D7%95%D7%9C-%D7%91%D7%94%D7%95%D7%93%D7%95",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%90%D7%A9%D7%A8%D7%AA-%D7%9B%D7%A0%D7%99%D7%A1%D7%94-%D7%9C%D7%A1%D7%A8%D7%99-%D7%9C%D7%A0%D7%A7%D7%94-2021",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%90%D7%A9%D7%A8%D7%AA-%D7%9B%D7%A0%D7%99%D7%A1%D7%94-%D7%A7%D7%A0%D7%93%D7%94-%D7%9E%D7%93%D7%A8%D7%99%D7%9A",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/visa-dubai-united-arab-emirates",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%9C%D7%95%D7%99%D7%90%D7%98%D7%A0%D7%9D-%D7%91%D7%90%D7%99%D7%A0%D7%98%D7%A8%D7%A0%D7%98",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/%D7%95%D7%99%D7%96%D7%94-%D7%90%D7%9C%D7%A7%D7%98%D7%A8%D7%95%D7%A0%D7%99%D7%AA-%D7%9C%D7%94%D7%95%D7%93%D7%95",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/tet-vietnamese-new-year",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  },
  {
    name: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0Meta?.name,
    path: "/index.php",
    component: component_45stubFWHgZDQQFdcwXsrIKp4rSg56OaCrwWSUL_zNPo7f6G0
  }
]